var map = {
	"./balloons.png": "jpJA",
	"./beachball.png": "ao6K",
	"./bird.png": "tY7X",
	"./butterflies.png": "tslc",
	"./cat.png": "9aLx",
	"./chain.png": "hejj",
	"./confetti.png": "1ab7",
	"./crown.png": "kvG9",
	"./earrings_01.png": "8nMi",
	"./earrings_02.png": "rczQ",
	"./flower.png": "wSRb",
	"./flowers.png": "haC4",
	"./glasses_01.png": "bqXO",
	"./glasses_02.png": "5S7o",
	"./glasses_03.png": "wGy0",
	"./glasses_04.png": "izlL",
	"./hat.png": "xij5",
	"./helmet.png": "tOO1",
	"./horse.png": "gvwz",
	"./leaf.png": "LrTL",
	"./necklace.png": "0mkz",
	"./paintsplatter.png": "ErX+",
	"./spoon.png": "6Pb+",
	"./tie.png": "cKhx",
	"./tuque.png": "JXDH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "179O";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail ^\.\/.*\.png$
// module id = 179O
// module chunks = 0